import { alpha } from '@mui/material/styles';
import {
    APP_STYLE_COMPONENT_COLORS as MSI_COMPONENT_COLORS,
    MSI_GEOMETRY,
    APP_STYLE_PALETTE as MSI_PALETTE,
    MSI_TYPE_SCALE,
    usesAppStyleGrammar,
} from './msiStyleTokens';

export const secondaryPanelSx = {
    border: (theme) => (
        usesAppStyleGrammar(theme) ? `1px solid ${MSI_PALETTE.line}` : undefined
    ),
    borderRadius: (theme) => (
        usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.panel}px` : undefined
    ),
    backgroundColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : undefined
    ),
    backgroundImage: (theme) => (usesAppStyleGrammar(theme) ? 'none' : undefined),
    boxShadow: (theme) => (usesAppStyleGrammar(theme) ? 'none' : undefined),
};

export const secondarySectionFrameSx = {
    border: '1px solid',
    borderColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.line : theme.palette.divider
    ),
    borderRadius: (theme) => (
        usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.panel}px` : 1
    ),
    backgroundColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : undefined
    ),
    overflow: 'hidden',
};

export const secondarySectionHeaderSx = {
    borderColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.lineDark : theme.palette.divider
    ),
    backgroundColor: (theme) => (
        usesAppStyleGrammar(theme)
            ? MSI_COMPONENT_COLORS.tableHeader
            : alpha(theme.palette.action.hover, theme.palette.mode === 'dark' ? 0.16 : 0.42)
    ),
};

export const secondaryActionButtonSx = {
    borderRadius: (theme) => (
        usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.button}px` : 999
    ),
    letterSpacing: (theme) => (usesAppStyleGrammar(theme) ? 0 : undefined),
    textTransform: (theme) => (usesAppStyleGrammar(theme) ? 'none' : undefined),
};

export const secondaryModalSx = {
    border: (theme) => (
        usesAppStyleGrammar(theme) ? `1px solid ${MSI_PALETTE.line}` : undefined
    ),
    borderRadius: (theme) => (
        usesAppStyleGrammar(theme) ? `${MSI_GEOMETRY.radii.panel}px` : 2
    ),
    backgroundColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : theme.palette.background.paper
    ),
    backgroundImage: (theme) => (usesAppStyleGrammar(theme) ? 'none' : undefined),
    boxShadow: (theme) => (
        usesAppStyleGrammar(theme) ? '0 16px 40px rgba(12, 23, 38, 0.12)' : theme.shadows[24]
    ),
};

export const authPanelSx = {
    border: (theme) => (
        usesAppStyleGrammar(theme) ? `1px solid ${MSI_PALETTE.line}` : undefined
    ),
    backgroundColor: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_PALETTE.surface : theme.palette.background.paper
    ),
    color: 'text.primary',
    boxShadow: (theme) => (
        usesAppStyleGrammar(theme) ? 'none' : undefined
    ),
};

export const authHeadingSx = {
    color: (theme) => (usesAppStyleGrammar(theme) ? MSI_PALETTE.ink900 : undefined),
    fontSize: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_TYPE_SCALE.panelTitle.fontSize : undefined
    ),
    fontWeight: (theme) => (
        usesAppStyleGrammar(theme) ? MSI_TYPE_SCALE.panelTitle.fontWeight : undefined
    ),
    letterSpacing: (theme) => (usesAppStyleGrammar(theme) ? 0 : undefined),
};

export const authRecaptchaSx = {
    mt: 1,
    minHeight: 1,
    '&:focus-within': {
        outline: (theme) => (
            usesAppStyleGrammar(theme)
                ? `2px solid ${MSI_COMPONENT_COLORS.focusBorder}`
                : undefined
        ),
        outlineOffset: 2,
    },
};
